import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PeaceOfMindSecured from "./sections/PeaceOfMindSecured";
import ProtectionPortfolio from "./sections/ProtectionPortfolio";
import InstantQuoteEngine from "./sections/InstantQuoteEngine";
import ClaimsAdvocacy247 from "./sections/ClaimsAdvocacy247";
import TheVanguardStandard from "./sections/TheVanguardStandard";
import CertifiedSecurityTrust from "./sections/CertifiedSecurityTrust";
import AgencyFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <PeaceOfMindSecured />
      <ProtectionPortfolio />
      <InstantQuoteEngine />
      <ClaimsAdvocacy247 />
      <TheVanguardStandard />
      <CertifiedSecurityTrust />
      <AgencyFooter />
    </div>;
}